export default __webpack_public_path__ + "static/media/slide_option_four.9bbcbc11.jpg";